export const environment = {
  production: true,
  version: '148541da58',
  site_version: 'SITE_VERSION'
};
